var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 23.6668C2.19167 23.6668 1.64236 23.4384 1.18542 22.9814C0.728472 22.5245 0.5 21.9752 0.5 21.3335V5.00016C0.5 4.3585 0.728472 3.80919 1.18542 3.35225C1.64236 2.8953 2.19167 2.66683 2.83333 2.66683H4V0.333496H6.33333V2.66683H15.6667V0.333496H18V2.66683H19.1667C19.8083 2.66683 20.3576 2.8953 20.8146 3.35225C21.2715 3.80919 21.5 4.3585 21.5 5.00016V21.3335C21.5 21.9752 21.2715 22.5245 20.8146 22.9814C20.3576 23.4384 19.8083 23.6668 19.1667 23.6668H2.83333ZM2.83333 21.3335H19.1667V9.66683H2.83333V21.3335ZM2.83333 7.3335H19.1667V5.00016H2.83333V7.3335Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarToday);
export default __webpack_public_path__ + "static/media/icon_calendar_today.0d7eb8f2313b25029609fc35a509f967.svg";
export { ForwardRef as ReactComponent };